import type {Fond} from 'src/typings';
import {IN_MEMORY_CACHE_STORAGE, cacheable} from 'shared/cache';
import type {FondedFieldType} from '../types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class FondsDataService {
    public static serviceName = 'fondsDataService';

    private static readonly ROUTE = 'fonds';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getAll(): Promise<Fond[]> {
        return this.ajaxService
            .createRequest(FondsDataService.ROUTE)
            .get();
    }

    @cacheable(IN_MEMORY_CACHE_STORAGE, 'FONDS')
    public async getById(fondId: number): Promise<Fond> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}`)
            .get();
    }

    @cacheable(IN_MEMORY_CACHE_STORAGE, 'INCLUDABLE_FONDS')
    public async getIncludableFonds(fondId: number): Promise<Fond[]> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}/includable`)
            .get();
    }

    @cacheable(IN_MEMORY_CACHE_STORAGE, 'INSERTABLE_FONDS')
    public async getInsertableFonds(rootFondId: number): Promise<Fond[]> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${rootFondId}/insertable`)
            .get();
    }

    public async getFondFieldTypes(fondId: number): Promise<FondedFieldType[]> {
        return this.ajaxService
            .createRequest(`${FondsDataService.ROUTE}/${fondId}/fields`)
            .get();
    }
}